import React from "react";
import { Spin } from 'antd';
import "./Loader.css";

export const Loader = () => (
  <>
    <div className="loaderRoot">
      <Spin />
    </div>
  </>
);
